import React from 'react'
import { FaBaby, FaBriefcaseMedical, FaBuilding, FaCalculator, FaGraduationCap, FaLanguage, FaLuggageCart,
     FaSchool, FaStaylinked } from 'react-icons/fa'
import { Link } from 'react-router-dom'

export const PInfoCateList = ({ cates }) => {
    const buildCateIcon = (id) => {
        let iconSize = 18;
        let IconItem = null;
        switch (id) {
            case 1:
                IconItem = FaLanguage;
                break;
            case 6:
                IconItem=FaStaylinked;
                break;
            case 7:
                IconItem=FaSchool;
                break;
            case 8:
                IconItem=FaBriefcaseMedical;
                break;
            case 11:
                IconItem=FaBuilding;
                break;
            case 15:
                IconItem=FaCalculator;
                break;
            case 16:
                IconItem=FaGraduationCap;
                break;
            case 17:
                IconItem=FaBaby;
                break;
            case 18:
                IconItem=FaLuggageCart;
                break;
            default:
                break;
        }
        return IconItem !== null ? <IconItem size={iconSize} /> : null;
    }
    const buildList = (list) => {
        return list.map(it => (
            <li key={it.id}>
                <Link to={`/plist/${it.id}`}>
                    {buildCateIcon(it.id)}
                    {it.name}
                </Link>
            </li>
        ))
    }
    return (
        <ul className='list-unstyled pcate-list-wrap'>
            {cates && cates.length > 0 && buildList(cates)}
        </ul>
    )
}
